// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"lang-es","441":"lang-en","782":"lang-en-US"}[chunkId] + "." + {"180":"17811ec3","441":"222c3c93","782":"628d3ffa"}[chunkId] + ".js";
};